module.exports = __webpack_public_path__ + "img/backup-batt-low.d283199e.svg";